import TabGroup from "./components/Subassets/TabGroup";
import {
  reactdata,
  nextdata,
  livewiredata,
  laraveldata,
  caseStudies,
} from "./Object/tabs";
import { Helmet, HelmetData } from "react-helmet-async";
import ToTop from "./components/Subassets/ToTop";
import { motion } from "framer-motion";

const helmetData = new HelmetData({});
const Works = () => {
  return (
    <>
      <Helmet helmetData={helmetData}>
        <meta
          name="description"
          content="My work inforamtion | Portfolio | Here some basic project i tried as frontend developer personally to know about my skills get them."
        />
        <title>DevProfile | Project Works</title>
      </Helmet>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1, delay: 1 }}
        transition={{
          ease: "easeInOut",
          duration: 0.7,
          delay: 0.15,
        }}
      >
        <section
          name="Works"
          aria-label="work section of projects "
          className="flex items-center justify-center bg-slate-800"
        >
          <div className="mx-2 my-10 space-y-5 rounded-md">
            <article
              aria-label="All Sample Project Work"
              className="py-16 mx-auto max-w-7xl sm:px-2 lg:px-8 bg-slate-500/50"
            >
              <div className="max-w-full px-4 mx-auto md:max-w-7xl lg:px-0">
                <div>
                  <h1
                    id="All Sample Project Work"
                    className="pb-4 text-3xl font-bold tracking-tight text-center text-gray-100 sm:text-4xl"
                  >
                    Some Sample Web Development Projects
                  </h1>
                </div>
                <TabGroup tabs={reactdata} />
                <TabGroup tabs={nextdata} />
                <TabGroup tabs={livewiredata} />
                <TabGroup tabs={laraveldata} />
              </div>
            </article>
            <article
              aria-label="Some UX Case Studies"
              className="py-16 mx-auto max-w-7xl sm:px-2 lg:px-8 bg-slate-500/50"
            >
              <div className="max-w-full px-4 mx-auto md:max-w-7xl lg:px-0">
                <div>
                  <h1
                    id="All Sample Project Work"
                    className="pb-4 text-3xl font-bold tracking-tight text-center text-gray-100 sm:text-4xl"
                  >
                    Some Ux Case Studies
                  </h1>
                </div>
                <TabGroup tabs={caseStudies} Case />
              </div>
            </article>
          </div>
        </section>
        <ToTop name="Works" />
      </motion.div>
    </>
  );
};

export default Works;
